export { AddBankModal } from './addBankModal';
export { AddCardModal } from './addCardModal';
export { AddUpiModal } from './addUpiModal';
export { GiftGoldWelcomeBanner } from './giftGoldWelcomeBanner';
export { SellKycModal } from './sellKycModal';
